<template>
	<div :class="[`code-block tc`, {active: isTabActive}, $css(styles.codeBlock, styles.codeBlockActive)]">
		<div :class="[`top-area pr overflow-hidden justify-center flex flex-column items-center`, $css(styles.topArea)]">
			<span :class="[`code-title`, $css(styles.codeTitle)]">Code</span>
			<button :class="[`btn fw5 f5 pointer flex items-center`, $css(styles.btn)]"
			@click="onCopyCodeClick">
				<span class="icon"><img src="../../assets/images/copy.svg" alt="copy"></span>
				<span class="text">Copy code to clipboard</span>
			</button>
			<span :class="[`info-text w-100 dn`, $css(styles.infoText)]">
				<i class="icon dib"><img src="../../assets/images/upload1.svg" alt="upload"></i>
				<span class="text">Import configuration or drag Json here</span>
			</span>
		</div>

		<article :class="[`code-container f4 fw8`, $css(styles.codeContainer)]">
			<pre v-highlightjs="codeSample">
				<code class="javascript"></code>
			</pre>
		</article>
	</div>
</template>

<script>
	import {mapState, mapActions} from "vuex";
	import consts from "@/common/consts";
	import {getInMediaQuery as gimq, MQ_SIZES} from "@/utils/cssUtils";
	import {types} from "@/store/modules/app";
	import {pushEvent} from "@/utils/analytics";
	import {contains} from "@/utils/domUtils";

	function styles() {
		return this.$style({
			codeBlock: gimq(
				[MQ_SIZES.W, {width: "100%", padding: "24px 66px 23px 68px"}],
				[MQ_SIZES.D, {padding: "20px", display: "none"}],
				[MQ_SIZES.M, {padding: "15px 16px 20px 18px"}]),
			codeBlockActive: this.isTabActive ? gimq(
				[MQ_SIZES.D, {display: "block"}],
				[MQ_SIZES.M, {display: "flex", flexWrap: "wrap"}]) : {},
			topArea: gimq(
				[MQ_SIZES.W, {flexDirection: "row", alignItems: "center", margin: "0 0 18px", justifyContent: "space-between"}],
				[MQ_SIZES.M, {margin: 0, justifyContent: "center", order: "2", width: "100%"}]),
			codeTitle: gimq(MQ_SIZES.W, {margin: "0 5px", display: "block"}),
			btn: gimq(
				[MQ_SIZES.W, {order: 3, margin: 0}],
				[MQ_SIZES.L, {fontSize: "12px"}]),
			infoText: gimq(
				[MQ_SIZES.W, {order: 2, margin: "0 10px", width: "55%"}],
				[MQ_SIZES.L, {width: "52%"}],
				[MQ_SIZES.M, {display: "none"}]),
			codeContainer: gimq(MQ_SIZES.S, {width: "100%"}),
		});
	}

	export default {
		name: "CodeTab",

		computed:{
			...mapState({
				isTabActive: (state) => (state.app.activeTab === consts.TABS.CODE),
				codeSample: (state) => "\n" + state.widget.codeSample,
				codeSampleConfig: (state) => state.widget.codeSampleConfig,
			}),
			styles,
		},

		methods: {
			...mapActions("app", [types.SET_NOTIFICATION]),
			onCopyCodeClick() {
				const config = this.codeSampleConfig;

				console.table(Object.assign({}, config));

				try {
					const tmpInput = document.createElement("input");
					tmpInput.setAttribute("type", "text");
					tmpInput.value = this.codeSample;
					document.body.appendChild(tmpInput);
					tmpInput.select();
					document.execCommand("copy");
					document.body.removeChild(tmpInput);

					this[types.SET_NOTIFICATION]({
						type: consts.NOTICE_TYPES.SUCCESS,
						text: "Code sample copied to clipboard successfully"
					});

					pushEvent("code", "copy", "button");
				}
				catch (ex) {
					console.error("[Demo]: FAILED TO COPY PALETTE !!!!!!!!!!!!", ex);
				}
			},
			onBrowserCopy(e) {
				try {
					if (e.target && contains(this.$el, e.target)) {
						pushEvent("code", "copy", "native");
					}
				}
				catch (ex) {
					console.error("[Demo]: failed to report browser copy event", ex);
				}
			},
		},

		mounted() {
			document.addEventListener("copy", this.onBrowserCopy);
		},

		destroyed() {
			document.removeEventListener("copy", this.onBrowserCopy);
		}
	}
</script>

<style lang="css">
	.hljs{display:block;overflow-x:auto;padding:0.5em;background:#1E1E1E;color:#DCDCDC}.hljs-keyword,.hljs-literal,.hljs-symbol,.hljs-name{color:#569CD6}.hljs-link{color:#569CD6;text-decoration:underline}.hljs-built_in,.hljs-type{color:#4EC9B0}.hljs-number,.hljs-class{color:#B8D7A3}.hljs-string,.hljs-meta-string{color:#D69D85}.hljs-regexp,.hljs-template-tag{color:#9A5334}.hljs-subst,.hljs-function,.hljs-title,.hljs-params,.hljs-formula{color:#DCDCDC}.hljs-comment,.hljs-quote{color:#57A64A;font-style:italic}.hljs-doctag{color:#608B4E}.hljs-meta,.hljs-meta-keyword,.hljs-tag{color:#9B9B9B}.hljs-variable,.hljs-template-variable{color:#BD63C5}.hljs-attr,.hljs-attribute,.hljs-builtin-name{color:#9CDCFE}.hljs-section{color:gold}.hljs-emphasis{font-style:italic}.hljs-strong{font-weight:bold}.hljs-bullet,.hljs-selector-tag,.hljs-selector-id,.hljs-selector-class,.hljs-selector-attr,.hljs-selector-pseudo{color:#D7BA7D}.hljs-addition{background-color:#144212;display:inline-block;width:100%}.hljs-deletion{background-color:#600;display:inline-block;width:100%}
</style>

<style lang="scss" scoped>
	@import "../../assets/scss/_variables.scss";

	.code-block {
		background: $white;
		padding: 17px 8px 17px 11px;
		width: 31.7%;
		display: block;
		text-align: initial;

		pre {
			margin-top: -20px;
		}

		.code-container {
			line-height: 18px;
			/*max-height: calc(100% - 100px);*/
			overflow-y: auto;
			max-height: 100%;
		}

		.code-title {
			font-size: 14px;
			line-height: 18px;
			color: $black;
			margin: 0 5.8% 0 2.7%;
			display: none;
		}

		.top-area {
			line-height: 20px;
		}

		.btn {
			color: $white;
			background: $orange;
			border-radius: 4px;
			letter-spacing: 0.07px;
			transition: background 0.4s ease;
			margin: 0 0 16px;
			padding: 6px;

			&:hover {
				color: $white;
				background: #a53a00;
			}

			.icon {
				display: inline-block;
				vertical-align: top;
				margin: 0 2px 0 0;
			}
		}

		.info-text {
			/*display: flex;*/
			align-items: center;
			justify-content: center;
			background: $catskill;
			letter-spacing: 0.06px;
			color: $oxford;
			padding: 6px;
			border-radius: 4px;
			margin: 0 0 10px;

			.icon {
				width: 20px;
				height: 20px;

				img {
					width: 100%;
				}
			}
		}
	}

</style>
